import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChildren, effect, input, output, signal } from '@angular/core';
import { TabComponent } from './tab.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  selector: 'ideals-tabs',
  styleUrls: ['./tabs.component.scss'],
  templateUrl: './tabs.component.html',
})
export class TabsComponent {
  readonly activeIndex = input<number>();

  readonly activeIndexChange = output<number>();
  
  readonly tabs = contentChildren(TabComponent);

  readonly #activeIndex = signal(0);

  constructor() {
    effect(() => {
      this.#activeIndex.set(this.activeIndex() ?? 0);
    });
  }

  protected selectTab(index: number): void {
    this.#activeIndex.set(index);
    this.activeIndexChange.emit(index);
  }

  protected isActive(index: number): boolean {
    return this.#activeIndex() === index;
  }
}
